export const HOME = "/";
export const ABOUT = "/about";
export const BLOGS = "/blogs";
export const VLOGS = "/vlogs";
export const MEDIA = "/media";
export const NEWS = "/news";
export const DEBATES = "/debates";
export const SOCIAL = "/social";
export const CONTACT = "/contact";
